<script lang="ts">
  import type { ButtonProps } from './button.types';
  import { buttonStyles } from './button.styles';
  import { css } from '@agapi/ui/panda/css';

  const {
    children,
    as = 'button',
    variant = 'primary',
    size = 'md',
    fullWidth,
    tabindex,
    css: cssProp,
    ...props
  }: ButtonProps = $props();
</script>

<svelte:element
  {...props}
  this={as}
  role={as === 'button' ? 'button' : as === 'a' ? 'link' : undefined}
  onclick={props.onclick}
  class={css(buttonStyles.raw({ variant, size, fullWidth }), cssProp)}
  tabindex={tabindex ?? (as === 'button' ? ((props as ButtonProps & { as: 'button' }).disabled ? -1 : 0) : 0)}
  {...(as === 'a' ? {
    href: (props as ButtonProps & { as: 'a' }).href,
    title: (props as ButtonProps & { as: 'a' }).title
  } : {})}
  {...(as === 'button' ? {
    type: (props as ButtonProps & { as: 'button' }).type ?? 'button',
    disabled: (props as ButtonProps & { as: 'button' }).disabled,
  } : {})}
>
  {@render children?.()}
</svelte:element>
